export default import.meta.ROLLDOWN_FILE_URL_nw2fxxXhIRyp1w4ag_P6OQ